import { create } from "zustand";

export type LabelMatchMode = "any" | "all";

/** Transient (not persisted) view filter: which labels are selected in the
 *  sidebar and whether a task must match ANY or ALL of them. Empty selection
 *  means "no filter" — every task is shown. Read by the calendar routes and the
 *  All-tasks list via `filterByLabels` in lib/label-filter.ts. */
interface LabelFilterState {
  selected: string[];
  mode: LabelMatchMode;
  toggle: (id: string) => void;
  clear: () => void;
  setMode: (mode: LabelMatchMode) => void;
}

export const useLabelFilterStore = create<LabelFilterState>((set, get) => ({
  selected: [],
  mode: "any",
  toggle(id) {
    const selected = get().selected;
    set({ selected: selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id] });
  },
  clear() { set({ selected: [] }); },
  setMode(mode) { set({ mode }); },
}));
